import { Phone, Mail, MapPin, MessageCircle, Clock } from "lucide-react";
import { PageHero } from "../components/site/PageHero";
import { RfqForm } from "../components/site/RfqForm";
import { Reveal } from "../components/site/Motion";
import { Downloads } from "../components/home/Downloads";
import { useSettings, waLink } from "../lib/api";
import { Seo, crumbsLd } from "../components/site/Seo";

const Info = ({ icon: Icon, label, children, testId }) => (
  <div data-testid={testId} className="flex gap-4 border-b border-slate-800 py-5">
    <Icon className="mt-0.5 h-5 w-5 shrink-0 text-sky-400" />
    <div><p className="eyebrow !text-[10px] text-slate-400">{label}</p><div className="mt-1 text-sm text-white">{children}</div></div>
  </div>
);

export default function Contact() {
  const s = useSettings();
  return (
    <div data-testid="contact-page">
      <Seo path="/contact" title="Contact & Request a Quote | Autocrat Rubber Industries" description="Send an RFQ to Autocrat Rubber Industries, Rajendra Park, Gurugram. Call or WhatsApp +91 98992 13153 or email autocratrubber@yahoo.com for rubber parts." jsonLd={crumbsLd([["Home", "/"], ["Contact", "/contact"]])} />
      <PageHero testId="contact-hero" video eyebrow="Contact / RFQ" lines={["Let's build", { text: "your part.", className: "text-outline" }]} crumbs={[{ to: "/", label: "Home" }, { label: "Contact" }]}>
        Share your requirement — drawing, sample, compound or volume. Our sales team responds with feasibility and pricing.
      </PageHero>
      <section className="bg-white py-20 md:py-28">
        <div className="container-x grid gap-14 lg:grid-cols-12">
          <Reveal className="lg:col-span-7">
            <p className="eyebrow text-[#0a6cff]">Request for quotation</p>
            <h2 className="font-display mb-10 mt-3 text-4xl font-extrabold uppercase text-slate-950 sm:text-5xl">Tell us what you need</h2>
            <RfqForm />
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-5">
            <div className="clip-corner bg-[#07090e] p-8">
              <Info icon={Phone} label="Phone" testId="contact-phone"><a href={`tel:${s.phone}`} className="hover:text-sky-400">{s.phone}</a></Info>
              <Info icon={MessageCircle} label="WhatsApp" testId="contact-whatsapp-link"><a href={waLink(s.whatsapp)} target="_blank" rel="noreferrer" className="hover:text-sky-400">Chat with sales →</a></Info>
              <Info icon={Mail} label="Email" testId="contact-email"><a href={`mailto:${s.email}`} className="break-all hover:text-sky-400">{s.email}</a></Info>
              <Info icon={MapPin} label="Factory address" testId="contact-address">
                {s.address}
                {s.map_link && <a href={s.map_link} target="_blank" rel="noreferrer" data-testid="contact-map-link" className="mt-2 block text-xs font-semibold uppercase tracking-widest text-sky-400 hover:text-sky-300">Get directions on Google Maps →</a>}
              </Info>
              <Info icon={Clock} label="Working hours" testId="contact-hours">{s.hours}</Info>
            </div>
            <div data-testid="contact-map-container" className="mt-4 aspect-[4/3] overflow-hidden border border-slate-200 grayscale-[0.6]">
              <iframe title="Autocrat Rubber Industries location" src={`https://maps.google.com/maps?q=${encodeURIComponent(s.map_query || s.address)}&z=15&output=embed`} className="h-full w-full" loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
            </div>
          </Reveal>
        </div>
      </section>
      <Downloads />
    </div>
  );
}
